/* ============================================================
   pop2026
   ============================================================ */

export const pop2026 = {
  id: "2",
  type: "playlist",
  featured: true,
  title: "Pulse Pop 2026",
  link: "pulse-pop-2026",
  playlistBg: "rgb(163, 77, 255)",
  imgUrl: "../image/listas/pulse-pop-2026/please-please-please.jpg", ///image/set/listas/pop-2026.jpg
  hoverColor: "rgb(163, 77, 255)",
  artist: "mixtape",
  artistImgUrl: "../image/djs/mixtape/mixtape.jpg",
  artistBio: "alibhtty",
  artistDownload: "Descargar",
  bannerUno: "",
  downloadData: [],
  playlistImages: [],
  playlistData: [
    {
      id: "1",
      songName: "Espresso",
      songimg: "../image/listas/pulse-pop-2026/espresso.jpg",
      songArtist: "Sabrina Carpenter",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/ij4uoztyzrbv3wqonz1rf/Sabrina-Carpenter-Espresso.mp3?rlkey=40djpxll8m7o2p37lpgepsq67&st=amdh3upe&dl=1",
      trackTime: "02:56",
      index: 0,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "2",
      songName: "Please Please Please",
      songimg: "../image/listas/pulse-pop-2026/please-please-please.jpg",
      songArtist: "Sabrina Carpenter",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/ls6qccxp6spwxxplw0pvi/Sabrina-Carpenter-Please-Please-Please.mp3?rlkey=jnlwes71vg3j7q6jmb41ad954&st=xgtj55dd&dl=1",
      trackTime: "03:06",
      index: 1,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "3",
      songName: "Training Season",
      songimg: "../image/listas/pulse-pop-2026/training-season.jpg",
      songArtist: "Dua Lipa",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/zhom58jmcpl2u53uc2qu6/Dua-Lipa-Training-Season.mp3?rlkey=wzdvxmktjcppvjc78wom8xlsh&st=mo40sfxw&dl=1",
      trackTime: "03:30",
      index: 2,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "4",
      songName: "Illusion",
      songimg: "../image/listas/pulse-pop-2026/illusion.jpg",
      songArtist: "Dua Lipa",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/wkgfapbcyuu9rz0x4gln4/Dua-Lipa-Illusion.mp3?rlkey=3zn6ac7fl8gx4oldufjp874na&st=mly6sh86&dl=1",
      trackTime: "03:08",
      index: 3,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "5",
      songName: "greedy",
      songimg: "../image/listas/pulse-pop-2026/greedy.jpg",
      songArtist: "Tate McRae",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/fejdcaeoya7ah7amftn2l/Tate-McRae-greedy.mp3?rlkey=yu79ky53csfneg7p49hq2kmze&st=xee10qbj&dl=1",
      trackTime: "02:12",
      index: 4,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "6",
      songName: "exes",
      songimg: "../image/listas/pulse-pop-2026/exes.jpg",
      songArtist: "Tate McRae",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/0jrfqvua4opkru73di8ql/Tate-McRae-exes.mp3?rlkey=wrjszlsn6l5t69mhl6jnn2jfs&st=vck4iq24&dl=1",
      trackTime: "02:39",
      index: 5,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "7",
      songName: "Dance Alone",
      songimg: "../image/listas/pulse-pop-2026/dance-alone.jpg",
      songArtist: "Sia",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/6y5ebd2a7xdyy3v8gx5nn/Sia-Dance-Alone.mp3?rlkey=7u80ca552rqwora2q5gi884jc&st=0se7cvil&dl=1",
      trackTime: "02:52",
      index: 6,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "8",
      songName: "Fortnight",
      songimg: "../image/listas/pulse-pop-2026/fortnight.jpg",
      songArtist: "Taylor Swift",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/nxqffshp4i2v4hejih7lb/Taylor-Swift-Fortnight.mp3?rlkey=klijeeokc21sx5mlqhexevl7c&st=v6ehdf67&dl=1",
      trackTime: "03:49",
      index: 7,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "9",
      songName: "Anti-Hero",
      songimg: "../image/listas/pulse-pop-2026/anti-hero.jpg",
      songArtist: "Taylor Swift",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/4xhx328hhexyperdygc3i/Taylor-Swift-Anti-Hero.mp3?rlkey=9oru5idtwmtl1hgyvvysscku4&st=w0f0ink6&dl=1",
      trackTime: "03:21",
      index: 8,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "10",
      songName: "Houdini",
      songimg: "../image/listas/pulse-pop-2026/houdini.jpg",
      songArtist: "Dua Lipa",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/685mx3rplgcy111qhm48l/Dua-Lipa-Houdini.mp3?rlkey=626bnac0oj4x5dsg1kxnkptgk&st=1ynn2u9d&dl=1",
      trackTime: "03:06",
      index: 9,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "11",
      songName: "Cruel Summer",
      songimg: "../image/listas/pulse-pop-2026/cruel-summer.jpg",
      songArtist: "Taylor Swift",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/4r1v3ed6wmyixv207e6tr/Taylor-Swift-Cruel-Summer.mp3?rlkey=yp391se298liywyygi8r20i2o&st=6lbtywzc&dl=1",
      trackTime: "02:58",
      index: 10,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "12",
      songName: "Lose Control",
      songimg: "../image/listas/pulse-pop-2026/lose-control.jpg",
      songArtist: "Teddy Swims",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/fqxf3bx2drmpzlr9l6ufg/Teddy-Swims-Lose-Control.mp3?rlkey=8ggv90od6qlxuw7g603m5vcsd&st=6yxaeh3s&dl=1",
      trackTime: "03:31",
      index: 11,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "13",
      songName: "Paint The Town Red",
      songimg: "../image/listas/pulse-pop-2026/paint-the-town-red.jpg",
      songArtist: "Doja Cat",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/kfmiwyj0y1j39q6rr27m0/Doja-Cat-Paint-The-Town-Red.mp3?rlkey=57ia4tw15akgt95vdm4osutjz&st=6blvag1z&dl=1",
      trackTime: "03:52",
      index: 12,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "14",
      songName: "Woman",
      songimg: "../image/listas/pulse-pop-2026/woman.jpg",
      songArtist: "Doja Cat",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/cm6sca71of5orhvklw7nf/Doja-Cat-Woman.mp3?rlkey=l4hrarhh6jqqfmc1mnzh1awmg&st=vigc37qk&dl=1",
      genre: "",
      trackTime: "02:53",
      index: 13,
    },
    {
      id: "15",
      songName: "Super Shy",
      songimg: "../image/listas/pulse-pop-2026/super-shy.jpg",
      songArtist: "NewJeans",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/lr4rfd7jtqz9zd5zso7ux/NewJeans-Super-Shy.mp3?rlkey=my7rqgrkljp8xc2mjmcopckzq&st=gbf1r0wv&dl=1",
      trackTime: "02:35",
      index: 14,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "16",
      songName: "Good Luck, Babe!",
      songimg: "../image/listas/pulse-pop-2026/good-luck-babe.jpg",
      songArtist: "Chappell Roan",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/67hcz4rc2rnlidbtksrfq/Chappell-Roan-Good-Luck-Babe.mp3?rlkey=wk5av9d22sq4s29b5zqyqjl91&st=n89uea1x&dl=1",
      trackTime: "03:38",
      index: 15,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "17",
      songName: "One Of Your Girls",
      songimg: "../image/listas/pulse-pop-2026/one-of-your-girls.jpg",
      songArtist: "Troye Sivan",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/4q8m2yz0a8nijerosedyg/Troye-Sivan-One-Of-Your-Girls.mp3?rlkey=e7wwaxe9jl7jgqazje46csa2r&st=v4zsxysf&dl=1",
      trackTime: "03:02",
      index: 16,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "18",
      songName: "Rush",
      songimg: "../image/listas/pulse-pop-2026/rush.jpg",
      songArtist: "Troye Sivan",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/uuctngovrtvv0o8nezcfy/Troye-Sivan-Rush.mp3?rlkey=iowiiwk0ibax5nf68x5fsjsj2&st=w33b2545&dl=1",
      trackTime: "02:36",
      index: 17,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "19",
      songName: "Feather",
      songimg: "../image/listas/pulse-pop-2026/feathers.jpg",
      songArtist: "Sabrina Carpenter",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/l6vsl863xkh9uugdbmgm7/Sabrina-Carpenter-Feather.mp3?rlkey=3wrxjcew3ml4ishezottyclxa&st=nbrocica&dl=1",
      trackTime: "03:06",
      index: 18,
      genre: "pop",
      genres: ["pop", "urban"],
    },
    {
      id: "20",
      songName: "Strangers",
      songimg: "../image/listas/pulse-pop-2026/strangers.jpg",
      songArtist: "Kenya Grace",
      artistLink: "",
      link: "https://dl.dropbox.com/scl/fi/l89b3r9jnnse41ld4yeek/Kenya-Grace-Strangers.mp3?rlkey=swffo6ubig8l99cuzjft972b4&st=yzu0gfi0&dl=1",
      trackTime: "02:53",
      index: 19,
      genre: "pop",
      genres: ["pop", "urban"],
    }
  ]
}
